import {h} from 'preact'
import ButtonControl from '../button-control'
import globals from '../../utils/globals'
import TextButton from '../ui-components/TextButton'
import InputGroup from '../ui-components/InputGroup'
import AnalyticsTooltip from '../ui-components/AnalyticsTooltip'
import Textarea from "../ui-components/Textarea";
import {Configuration, Provider} from "./types";
import AbstractProvider, {ProvidedItems} from "./AbstractProvider";

interface Props {
  provider: Provider
  onMount: () => void
  onSubmit: (configuration: Configuration) => void
  ssoProxyUrl: string
}

const SAMLSetup = (props: Props) => {
  const metadataUrl = `${props.ssoProxyUrl}saml/metadata?customer=${globals('communityId')}`

  function downloadMetadata() {
    window.open(metadataUrl)
  }

  function copyMetadataUrl() {
    const tmp = document.createElement('textarea')
    tmp.value = metadataUrl
    document.body.appendChild(tmp)
    tmp.select()
    document.execCommand('copy')
    document.body.removeChild(tmp)
  }

  return <AbstractProvider {...props}>
    {({configuration, onSubmit, getError, getSubmitButtonProps, onInputChange} : ProvidedItems) =>
        <div className='form-enumeration'>
          <div className='form-enumeration__number'>1</div>
          <div className='form-enumeration__step-title'>Download metadata using the button below</div>
          <div className='form-enumeration__step-line'/>
          <div className='form-enumeration__step-content'>
            <ButtonControl
                class='download-saml-metadata'
                onClick={downloadMetadata}
                title='Download metadata'
            />
            <TextButton class='copy-download-link' onClick={copyMetadataUrl}>
              Copy the download link
            </TextButton>
          </div>
          <div className='form-enumeration__number'>2</div>
          <div className='form-enumeration__step-title form-enumeration__step-title--red'>
            Configure identity provider information using metadata
          </div>
          <div className='form-enumeration__step-line'/>
          <div className='form-enumeration__step-empty'/>
          <div className='form-enumeration__number'>3</div>
          <div className='form-enumeration__step-title'>Fill in identity provider information</div>
          <div/>
          <div className='form-enumeration__step-content'>
            <p>Once you fill in these details and press 'Save changes', users on the community will
              be able to login using SSO, given all the information is provided is correct.</p>
            <form onSubmit={onSubmit}>
              <div>
                {props.provider.fields.map(field => {
                  const error = getError(field.name)
                  return field.name == 'idp_public_key' ?
                      <div className='form-group'>
                        <label>{field.label} <AnalyticsTooltip title={field.help ? field.help: ''}/></label>
                        <Textarea
                            value={configuration[field.name]}
                            onContentChange={(value: string) => onInputChange(field.name, value)}
                            class={`form-control ${error ? 'validation-error' : ''}`}
                        />
                        {error &&
                        <div className='validation-error error-message'>{error}</div>}
                      </div>
                      :
                      <InputGroup
                          title={<div>{field.label} <AnalyticsTooltip title={field.help ? field.help: ''}/></div>}
                          type='text'
                          value={configuration[field.name]}
                          onChangeCallback={(e: ChangeEvent) => onInputChange(field.name, e.target.value)}
                          error={getError(field.name) || undefined}
                      />
                })}
              </div>
              <div>
                <ButtonControl {...getSubmitButtonProps()} />
                <ButtonControl
                    title='Cancel'
                    variant='secondary'
                    onClick={() => window.location.assign('/integration/sso')}
                />
              </div>
            </form>
          </div>
        </div>
    }
  </AbstractProvider>
}

export default SAMLSetup
